import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { ListItemPosition } from './UserRightsStyles';
import React from 'react';
import PropTypes from 'prop-types';
import { AccordionWrapper } from 'components/common/SurfaceStyles';
import { Grid, Typography } from '@mui/material';

export const UserRightItemComponent = ({ data }) => {
    return <AccordionWrapper
        title={data.authorizationName}
        content={(
            <>
                {data.isRefined && (
                    <Grid container spacing={2}>
                        {data.documentTypeStates.map(docTypeState => (
                            <Grid item xs={12} md={6} key={docTypeState.documentTypeName}>
                                <Typography fontWeight='bold'>{docTypeState.documentTypeName}</Typography>
                                <List dense={true}>
                                    {docTypeState.documentStates.map(docState => (
                                        <ListItemPosition key={docState}>
                                            <ListItemText primary={docState} />
                                        </ListItemPosition>
                                    ))}
                                </List>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </>
        )}
    />
}

UserRightItemComponent.propTypes = {
    data: PropTypes.object.isRequired
};

export default UserRightItemComponent;
